import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import React from "react";

interface DienstCardProps {
    title: string;
    cardId: string;
    subtitle: string;
    bgColor: string;
    bgIcon: string;
    cols: string;
    faIcon: IconProp;
}
const DienstCard: React.FC<DienstCardProps> = ({title, subtitle, bgColor, bgIcon, faIcon, cardId, cols}) => {
    return (
        <>
            <div
                id={cardId}
                className={`${cols} d-flex`}>
                <div className={`card-grid-1 hover-up py-5 ${bgIcon} ${bgColor}`}>
                    <div className="grid-1-img">
                        <FontAwesomeIcon icon={faIcon} size='4x'/>
                    </div>
                    <h3 className="text-heading-6 mt-20">
                        {title}
                    </h3>
                    <p className="text-body-excerpt mt-20">
                        {subtitle}
                    </p>
                </div>
            </div>
        </>
    );
};

export default DienstCard;
